import { Link, useLocation } from "react-router";
import "./CareNav.css";
import { careData } from "../../../../utils/careData";

export const CareNav = () => {
  const { pathname } = useLocation();
  const currentPath = pathname.replace(/\/+$/, "").toLowerCase();

  return (
    <nav className="care-navigation" aria-label="Уход за вещами">
      {[{ title: "Об уходе", link: "" }, ...careData].map((item) => {
        const to = item.link ? `/care/${item.link}` : "/care";
        const isActive = currentPath === to;

        return (
          <Link
            key={to}
            to={to}
            aria-current={isActive ? "page" : undefined}
            className={`care-navigation-item${isActive ? " care-navigation-active" : ""}`}
          >
            {item.title}
          </Link>
        );
      })}
    </nav>
  );
};
